import { Suspense } from "react";
import { LoadingModal } from "../LoadingModal";

export const WithSuspense = ({ load : componentToRender }) => {
	return <Suspense fallback={<LoadingModal />}>{componentToRender}</Suspense>;
};
